import React from 'react';
import TextField from '@mui/material/TextField';

import { Tooltip } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_FONTS, ENUM_COLORS } from '@commons/Text';

import { InputContainer, TextWithToolTipContainer, TooltipContainer } from './styledComponents';

export const MuiNumberInput = (props) => {
  const { value, onChange, placeholder, customStyle, label, tooltipText } = props;

  return (
    <InputContainer>
      <TextWithToolTipContainer>
        {label && (
          <Text color={ENUM_COLORS.DARKER} font={ENUM_FONTS.TEXT_SMALL}>
            {label}
          </Text>
        )}
        {tooltipText && (
          <TooltipContainer>
            <Tooltip className="tooltip" text={tooltipText} displayBigger />
          </TooltipContainer>
        )}
      </TextWithToolTipContainer>
      <TextField
        id="outlined-basic"
        placeholder={placeholder}
        sx={{ width: 240, ...customStyle }}
        type="number"
        value={value}
        variant="outlined"
        onChange={(e) => onChange(e.target.value)}
      />
    </InputContainer>
  );
};
